<!-- 
メール通知設定の一覧画面
@props
  itemList : 分類の配列
  canAddCategory : 分類を追加できる状態であればtrue、そうでなければfalseを指定する
-->

<template>
  <div>
    <div class="ml-2 mt-12 text-h5">メール通知設定</div>
    <div class="ml-4 blue-grey--text">メール通知を希望する分類にチェックを入れてください。</div>
    <v-data-table
      locale="jp"
      mobile-breakpoint="0"
      :headers="headers"
      :items="itemList"
      :custom-sort="sortFunction"
      item-key="recordId"
      hide-default-footer
      :single-select="false"
      :search="searchCondition"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      @page-count="pageCount = $event"
      no-results-text="検索条件に合うデータがありません"
      no-data-text="データがありません"
    >
      <!-- テーブルのコンテンツの定義 -->
      <template v-slot:[`item.category`]="{ item }">
        <td class="fixed-width-300 text-truncate">{{ item.category }}</td>
      </template>
      <template
        v-slot:[`item.mailSetting`]="{ item }"
      >
        <v-simple-checkbox
          :value="item.mailSetting"
          @input="selectedCheckbox(item)"
        >
        </v-simple-checkbox>
      </template>
    </v-data-table>
    <div class="text-center pt-2">
      <v-pagination
        v-model="page"
        :length="pageCount"
        :total-visible="7"
      ></v-pagination>
    </div>
    <!-- 確認ダイアログ -->
    <confirm-dialog ref="confirm_category_delete" @on-click-ok="deleteCategory">
      分類を削除します。よろしいですか？
    </confirm-dialog>
    <confirm-dialog
      ref="confirm_category_edit"  @on-click-ok="editCategory">
      分類を編集します。よろしいですか？
    </confirm-dialog>
    <confirm-dialog ref="confirm_category_cannot_delete" @on-click-ok="Category">
      この分類を設定したお知らせが登録されているため削除できません。
    </confirm-dialog>

    <v-container style="max-width: 800px">
      <v-row justify="center" style="text-align: center">
        <v-col cols="6">
          <v-btn
            color="secondary"
            outlined
            class="ma-2"
            width="200"
            @click="cancel"
            >キャンセル</v-btn
          >
        </v-col>
        <v-col cols="6">
          <v-btn
            color="primary"
            class="ma-2"
            width="200"
            @click="register(itemList)"
            >登録</v-btn
          >
        </v-col>
      </v-row>
    </v-container>

  </div>
</template>

<script>
import ConfirmDialog from "../dialog/confirm.vue";
import valueConverter from "../../logic/common/value-converter";
import AlertBuilder from "../../logic/common/alert-contents";
import Api from "@/logic/api/api.js";
import valueMapper from "../../logic/common/value-mapper";
export default {
  props: ["itemList", "canAddCategory"],
  components: {
    "confirm-dialog": ConfirmDialog,
  },
  computed: {
  },
  data() {
    return {
      // 検索条件（入力中）
      search: "",
      // 検索条件（一覧反映中）
      searchCondition: "",
      // 表示中のページ番号
      page: 1,
      // ページ数
      pageCount: 0,
      // ページあたりに表示するユーザー件数
      itemsPerPage: 20,
      // 選択中のユーザー情報
      selected: [],
      // 一覧のヘッダ定義
      headers: [
        {
          text: "分類",
          align: "start",
          value: "category",
          class: "grey darken-1 white--text",
          width: "300px",
        },
        {
          text: "メール設定",
          align: "start",
          value: "mailSetting",
          class: "grey darken-1 white--text",
          width: "300px",
        },
      ],
      // メニューの一覧
      items: [
      ],
    };
  },
  methods: {
    /**
     * 並び替えをカスタマイズする
     */
    sortFunction(items, sortBy, sortDesc) {
      if (sortBy.length == 0) {
        const userGroupIds = this.$store.getters.userGroupIds;
        return valueConverter.dataTableCustomSort(
          items,
          ["groupName"],
          [false],
          (a, b) => {
            // ログインユーザーの所属グループと同じIDであれば先頭に表示する
            if (userGroupIds.includes(a.groupId)) {
              return -1;
            }
            if (userGroupIds.includes(b.groupId)) {
              return 1;
            }
            // ログインユーザー以外のユーザーはデフォルトの比較方法で判定を行う
            return undefined;
          }
        );
      }
      return valueConverter.dataTableDefaultSort(items, sortBy, sortDesc);
    },

    /**
     * 更新データを作成する
     */
     buildUpdateData(itemList) {
      return {
        setting_list: itemList
          .map((item) => {
            return {
              category_id: item.categoryId,
              status: item.mailSetting,
            };
          }),
      };
    },

    /**
     * データを登録する
     */
     register(itemList) {
      this.delayCheck = true;
      this.clearMessage();
      // リクエストパラメータを作成する
      let updateUrl = "";
      let postData = null;
      updateUrl = "/admin/email/notification/setting/update";
      postData = this.buildUpdateData(itemList);
      // APIを実行する
      this.$store.commit("setWaiting", true);
      Api.call(updateUrl, postData)
        .then(() => {
          this.$store.commit("setWaiting", false);
          this.$router.push("/information");
        })
        .catch((error) => {
          this.$store.commit("setWaiting", false);
          console.log("error = " + error);
          console.log("error.status = " + error.status);
          if (error == "SyntaxError: Unexpected end of JSON input") {
            console.log("JSONエラーは後で確認");
            this.$store.commit("setWaiting", false);
            this.$router.push("/information");
          }
          const message = valueMapper
            .map({
              401: AlertBuilder.invalid(),
              409: AlertBuilder.error("編集が競合しています"),
            })
            .getOrElse(error.status, AlertBuilder.error("更新に失敗しました"));
          if (message.isInvalid) {
            Api.resolve(error);
          } else {
            this.showMessage(message);
          }
        });
      },

    selectedCheckbox(item) {
      item.mailSetting = !item.mailSetting;
    },

    /**
     * メッセージをクリアする
     */
     clearMessage() {
      this.errors = [];
    },

    cancel() {
      this.$router.push("/information");
    },
  },
};
</script>

<style>
th {
  background-color: #757575 !important;
}
th.sortable .v-data-table-header__icon {
  color: rgb(255, 255, 255, 0.15) !important;
}
th.sortable.active .v-data-table-header__icon {
  color: rgb(255, 255, 255, 1) !important;
}
</style>
